import { styled } from '@mui/system';
import { Step, Stepper } from '@mui/material';

export const StyledSection = styled('section')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

export const StyledStepper = styled(Stepper)(({ theme }) => ({
  backgroundColor: 'inherit',
  [theme.breakpoints.down('sm')]: {
    padding: '24px 8px'
  }
}));

export const StyledStep = styled(Step)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: 0,
    maxWidth: 65
  }
}));
